import React from 'react'
import { Link } from 'react-router-dom'

import MobileNavigation from './components/mobileNavigation'
import Navigation from './components/navigation'
import Footer from './components/footer'

import './scss/style.scss'

const Themes = () => (
  <>
    <MobileNavigation />
    <header className="pt-120 bg-light header_1">
      <Navigation />
    </header>

    <section className="pt-105 pb-100 bg-dark showcase_5">
      <div className="container px-xl-0">
        <div className="row justify-content-center text-center color-white">
          <div className="col-xl-9 col-lg-10">
            <h1>Free Bootstrap Themes</h1>
            <div className="mt-25 mb-40 f-22 text-adaptive">Browse a regularly evolving theme catalog of free Bootstrap themes. Download themes directly or apply more customizations in the builder. Bootstrap themes are fully customized and ready-made design systems you can use free for you and your clients.</div>
          </div>
        </div>
        <div className="row justify-content-center text-center text-md-left">
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_1.jpg" srcSet="/images/themes/showcase_5_img_1@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Superhero</div>
              <div className="color-heading text-adaptive">Bright and energetic, this marvelous Bootstrap theme has superpowers to get any business back on track</div>
              <Link to="/app/project/GuooRLwBLxKl" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_2.jpg" srcSet="/images/themes/showcase_5_img_2@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Materia</div>
              <div className="color-heading text-adaptive">Classic principles of good design with bold graphics and expressive coloring underlie this beautiful Bootstrap template.</div>
              <Link to="/app/project/tDgHGhgLEAYH" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_3.jpg" srcSet="/images/themes/showcase_5_img_3@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Journal</div>
              <div className="color-heading text-adaptive">Soft muted colors and smooth edges are what distinguish Journal Bootstrap UI from the others.</div>
              <Link to="/app/project/wWpIOvSBSEwS" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_4.jpg" srcSet="/images/themes/showcase_5_img_4@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Solar</div>
              <div className="color-heading text-adaptive">Bright as the Sun, this olive green theme brings a positive mood to every project with ease.</div>
              <Link to="/app/project/JfnwWFJRjGnp" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_5.jpg" srcSet="/images/themes/showcase_5_img_5@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Sandstone</div>
              <div className="color-heading text-adaptive">Black never gets old, especially when it comes to business matters. Dark nature produces a powerful effect.</div>
              <Link to="/app/project/UroRGaxfXxdg" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_6.jpg" srcSet="/images/themes/showcase_5_img_6@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Cerulean</div>
              <div className="color-heading text-adaptive">Cerulean engages the viewers with its gorgeous blue tone that naturally strengthens the businesslike atmosphere.</div>
              <Link to="/app/project/eysniHlzxNSi" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_7.jpg" srcSet="/images/themes/showcase_5_img_7@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Cyborg</div>
              <div className="color-heading text-adaptive">The same blue but with bright accents on the call-to-actions, Cyborg UI easily establishes focal points on the screen.</div>
              <Link to="/app/project/vsBQXplvEzul" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_8.jpg" srcSet="/images/themes/showcase_5_img_8@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Slate</div>
              <div className="color-heading text-adaptive">Coil-inspired coloring with traditional gradient styles for the buttons, Slate instills a sense of seriousness within seconds.</div>
              <Link to="/app/project/MjrwgQJtoYUV" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_9.jpg" srcSet="/images/themes/showcase_5_img_9@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">United</div>
              <div className="color-heading text-adaptive">The intense color of orange coupled with some fancy pale tones gives you some room for experiments.</div>
              <Link to="/app/project/NrACtlaOLCNQ" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_10.jpg" srcSet="/images/themes/showcase_5_img_10@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Lumen</div>
              <div className="color-heading text-adaptive">Lumen gets its beauty from dusk blue and beautiful 3D styles applied to buttons and small controls.</div>
              <Link to="/app/project/StgPKlEhuaWV" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_11.jpg" srcSet="/images/themes/showcase_5_img_11@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Pulse</div>
              <div className="color-heading text-adaptive">Lying in the heart of the aesthetics, luxurious purple gives these ultra-thin UI components a majestic feel.</div>
              <Link to="/app/project/iIFADbwMUkHo" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_12.jpg" srcSet="/images/themes/showcase_5_img_12@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Simplex</div>
              <div className="color-heading text-adaptive">With classic coloring and basic styles, Simplex maintains a bit of simplistic feel, yet it is only for the best.</div>
              <Link to="/app/project/KFEuubTyXwQL" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_13.jpg" srcSet="/images/themes/showcase_5_img_13@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Cosmo</div>
              <div className="color-heading text-adaptive">Although blue is a primary color here, yet the theme has some saucy tones like pink or lilac to place accents.</div>
              <Link to="/app/project/IdeqJQMwWUwS" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_14.jpg" srcSet="/images/themes/showcase_5_img_14@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Flatly</div>
              <div className="color-heading text-adaptive">Reimagined traditional approaches by using flat style and refreshing tones for buttons, navbars, and labels.</div>
              <Link to="/app/project/WzIGCuJqhghN" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_15.jpg" srcSet="/images/themes/showcase_5_img_15@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Litera</div>
              <div className="color-heading text-adaptive">Litera will impress your visitors with the soft rounded shapes that are ideal for small screens of cellphones and tablets.</div>
              <Link to="/app/project/YMaJJLGezWbs" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_16.jpg" srcSet="/images/themes/showcase_5_img_16@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Sketchy</div>
              <div className="color-heading text-adaptive">The sleek hand-written appeal makes Sketchy UI feel a bit rustic but still eye-catching and impressive.</div>
              <Link to="/app/project/uhPrFvLSfVUW" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_17.jpg" srcSet="/images/themes/showcase_5_img_17@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Spacelab</div>
              <div className="color-heading text-adaptive">Opting for never-dying gradient styles, Spacelab UI components feel incredibly pushy and alluring.</div>
              <Link to="/app/project/mJwvCtNdZQtg" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
          <div className="mt-30 col-xl-4 col-md-6 col-sm-8">
            <img src="/images/themes/showcase_5_img_18.jpg" srcSet="/images/themes/showcase_5_img_18@2x.jpg 2x" alt="" className="radius10 noradius_bottom w-full" />
            <div className="px-30 pt-20 pb-30 bg-white radius10 noradius_top inner">
              <div className="mb-10 f-22 title">Minty</div>
              <div className="color-heading text-adaptive">With its fabulous coloring and styles, Mint gives any project refreshing summer vibes that are hard to resist.</div>
              <Link to="/app/project/PWJVsLuAHWRv" className="btn mt-20 sm border-gray color-main f-16">Customize</Link>
            </div>
          </div>
        </div>
      </div>
    </section>

    <section className="pt-105 pb-100 bg-light text-center pricing_table_7">
      <div className="container px-xl-0">
        <div className="row justify-content-center">
          <div className="col-xl-8 col-lg-10">
            <h2 className="mb-15 small">Cost?</h2>
          </div>
          <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10">
            <div className="mb-50 f-22 color-heading text-adaptive">Bootstrap.build is a free Bootstrap builder.</div>
          </div>
        </div>
        <div className="row justify-content-center">
          <div className="col-xl-6 col-lg-7 col-md-8 col-sm-10">
            <div className="pt-40 pb-45 radius10 inner">
              <div className="row justify-content-center no-gutters">
                <div className="col-xl-7 col-lg-8 col-sm-9 col-11">
                  <div className="f-28 title">100% Free</div>
                  <div className="mt-25 f-14 text-uppercase semibold sp-20">18.000 users</div>
                  <ul
                    style={{ listStyleType: 'none', padding: 0, marginBottom: 0 }}
                    className="mt-10 color-heading f-18 medium text-adaptive"
                  >
                    <li>Advanced bootstrap builder mode</li>
                    <li>Import / export themes</li>
                    <li>Unlimited private projects</li>
                    <li>Auto-updated CDN</li>
                    <li>Export SASS and CSS</li>
                    <li>Reuse hundreds of free themes</li>
                  </ul>
                  <Link to="/signup" className="btn mt-35 lg action-2">Sign Up</Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>

    <Footer />
  </>
)

export default Themes
